<div class="dialog">
    <h2 class="dialog__title">
        Delete trip
        <br/>
        <span class="delete-trip-name">{{data.tripName}}</span>
    </h2>

    <p class="dialog__description">
        Are you sure you want to delete this trip from your saved trips list?
        <br/>
        <br/>
        This action cannot be undone.
    </p>

    <div class="dialog__actions">
        <button mat-ripple class="dialog__button dialog__button--cancel" (click)="closeModal(false)">
            Cancel
        </button>
        <button mat-ripple class="dialog__button dialog__button--confirm" (click)="closeModal(true)">
            Delete
        </button>
    </div>
</div>
